module.exports = __webpack_public_path__ + "static/fonts/PorscheNext-BoldItalic.bb9c15c2.otf";